/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How the card information was entered into the point of sale terminal.
 */
export const EntryMode = {
  Contactless: "contactless",
} as const;
/**
 * How the card information was entered into the point of sale terminal.
 */
export type EntryMode = ClosedEnum<typeof EntryMode>;

/** @internal */
export const EntryMode$inboundSchema: z.ZodNativeEnum<typeof EntryMode> = z
  .nativeEnum(EntryMode);
/** @internal */
export const EntryMode$outboundSchema: z.ZodNativeEnum<typeof EntryMode> =
  EntryMode$inboundSchema;
